module.exports = __webpack_public_path__ + "media/assets/3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/3.svg
// module id = 14
// module chunks = 0